import React from 'react';
import {
  Button,
  Flex,
  Link,
  Modal,
  Text,
  Title
} from '@gjensidige/builders-components';

interface ErrorObjectProps {
  propertyIdExampleIllustration: string;
  onCloseErrorModal: () => void;
  errorObject: {
    error: boolean;
    title: string;
    message: string;
    statusCode: number;
  };
}

const CustomerServiceDetails = () => (
  <div className="customer-service-contact-info-container">
    <Title as="h2" size="5" className="customer-service-box-header">
      Du når oss på
    </Title>
    <Text size="body" className="helper-and-contact-link">
      Telefon: <Link href="tel:0104839512">010-483 95 12</Link>
    </Text>
    <Text size="body" className="helper-and-contact-link">
      E-post: <Link href="mailto:info@gjensidige.se">info@gjensidige.se</Link>
    </Text>
  </div>
);

const showCustomerServiceDetails = (statusCode: number) => {
  switch (statusCode) {
    case 530:
    case 541:
      return false;
    default:
      return true;
  }
};

export const CustomErrorModal = ({
  errorObject,
  onCloseErrorModal,
  propertyIdExampleIllustration
}: ErrorObjectProps) => {
  const { message, title, statusCode, error } = errorObject;
  const noPropertyIdmatch = statusCode === 530;
  const customerServiceDetails = showCustomerServiceDetails(statusCode);

  return (
    <Modal
      open={error}
      onClick={onCloseErrorModal}
      strict={true}
      aria-label="Fel vid hämta fastighetsinformation"
      closeLabel="Stäng felmeddelande"
      className="error-helper-modal"
    >
      <Flex
        justify="center"
        className="error-helper-modal-container"
        direction="column"
      >
        <div className="custom-error-modal-text-container">
          <Title as="h2" size="4" className="error-title">
            {title}
          </Title>
          <Text
            size="body"
            className="error-message"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
        {noPropertyIdmatch && (
          <Flex className="property-id-image-container" direction="column">
            <img
              src={propertyIdExampleIllustration}
              alt=""
              className="property-id-image"
            />
            <Text size="body" className="custom-error-modal-text">
              Prova igen, eller fortsätt med din gatuadress.
            </Text>
          </Flex>
        )}
        {customerServiceDetails && (
          <Flex>
            <CustomerServiceDetails />
          </Flex>
        )}
        <div>
          <Button
            variant="primary"
            className="error-primary-button"
            onClick={onCloseErrorModal}
          >
            Stäng
          </Button>
        </div>
      </Flex>
    </Modal>
  );
};
